import TabapayTransactionSuccess from 'features/moveMoney/screens/dcf/tabapay/TabapayTransactionSuccess';
import React from 'react';

export default function TabapaySuccessScreenPage() {
  return <TabapayTransactionSuccess />;
}
